import { useEffect, useState } from "react";
import { Button } from "../../../../components/ui/button";
import { ChevronRight, X } from "lucide-react";

interface DeviceErrorProps {
    error: number | null | undefined;
    errorCodes: {
        code: string;
        title: string;
        description: string;
        number: number;
        device_model_id: number;
    }[];
    onMoreDetails?: () => void;
}

const DeviceError = ({ error, errorCodes, onMoreDetails }: DeviceErrorProps) => {
    const [isHidden, setIsHidden] = useState(false);

    const currentErrorValue = error;

    useEffect(() => {
        if (currentErrorValue == null || currentErrorValue === 0) return;
        setIsHidden(false);
    }, [currentErrorValue]);

    // No error
    if (currentErrorValue == null || currentErrorValue === 0) return null;

    const errorDetails = errorCodes.find((e) => e.number === currentErrorValue);
    if (!errorDetails || isHidden) return null;

    return (
        <div className="fixed inset-x-0 bottom-4 z-[9999] px-4">
            <div className="max-w-3xl mx-auto bg-red-500 rounded-lg shadow-lg">
                <div className="p-4 sm:p-5 relative">
                    <button onClick={() => setIsHidden(true)} className="absolute -top-2 -right-2 bg-white rounded-full p-1 shadow-md hover:bg-gray-100 transition-colors">
                        <X className="w-4 h-4 text-red-500" />
                    </button>
                    <div className="flex gap-4">
                        <div className="flex-shrink-0">
                            <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white/20 flex items-center justify-center">
                                <svg className="w-6 h-6 sm:w-7 sm:h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                </svg>
                            </div>
                        </div>
                        <div className="flex-1 min-w-0">
                            <div className="flex justify-between items-start gap-4">
                                <div className="flex-1">
                                    <h3 className="text-base sm:text-lg font-semibold text-white">{errorDetails.title}</h3>
                                    <p className="text-sm text-white/90 leading-relaxed mt-1">{errorDetails.description}</p>
                                </div>
                                <div className="flex flex-col items-end gap-2">
                                    <span className="inline-flex items-center rounded-md bg-white/20 px-2.5 py-1 text-xs font-medium text-white">Error Code: {errorDetails.code}</span>
                                    <Button variant="secondary" size="sm" onClick={onMoreDetails} className="bg-white/20 text-white hover:bg-white/30 transition-colors">
                                        More Details
                                        <ChevronRight className="ml-2 h-4 w-4" />
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeviceError;
